import React from 'react';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
// Custom Yelp Icon since it's not standard in lucide-react
const YelpIcon = ({
  size = 24,
  className = ''
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-111">
    <path d="M12.5 2.5c-1.5 0-2.5 1-2.5 2.5v4.5c0 1.5 1 2.5 2.5 2.5s2.5-1 2.5-2.5v-4.5c0-1.5-1-2.5-2.5-2.5z" data-id="element-112" />
    <path d="M14.5 13.5l4-2.5c1.5-.5 3 .5 3 2s-1.5 2.5-3 2.5l-4-2z" data-id="element-113" />
    <path d="M13.5 15.5l2.5 4c.5 1.5-.5 3-2 3s-2.5-1.5-2.5-3l-2-4z" data-id="element-114" />
    <path d="M10.5 14.5l-4 2.5c-1.5.5-3-.5-3-2s1.5-2.5 3-2.5l4 2z" data-id="element-115" />
    <path d="M11.5 12.5l-2.5-4c-.5-1.5.5-3 2-3s2.5 1.5 2.5 3l2 4z" data-id="element-116" />
  </svg>;
export function Footer() {
  return <footer className="bg-warm-bg pt-16 pb-8 border-t border-divider" data-id="element-117">
      <div className="container mx-auto px-4 md:px-8" data-id="element-118">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 mb-16 text-center md:text-left" data-id="element-119">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-120">
            <a href="#" className="font-serif text-3xl font-semibold tracking-wide text-text-dark mb-4" data-id="element-121">
              Be Clinical
            </a>
            <p className="text-text-dark/60 text-sm max-w-xs" data-id="element-122">
              Advanced regenerative aesthetics focusing on natural,
              science-backed results.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-123">
            <h4 className="font-serif text-lg text-text-dark mb-2" data-id="element-124">Explore</h4>
            <a href="#" className="text-text-dark/70 hover:text-gold transition-colors text-sm" data-id="element-125">
              Services
            </a>
            <a href="#" className="text-text-dark/70 hover:text-gold transition-colors text-sm" data-id="element-126">
              About Us
            </a>
            <a href="#" className="text-text-dark/70 hover:text-gold transition-colors text-sm" data-id="element-127">
              Patient Reviews
            </a>
            <a href="#" className="text-text-dark/70 hover:text-gold transition-colors text-sm" data-id="element-128">
              Contact
            </a>
          </div>

          {/* Contact & Social */}
          <div className="flex flex-col items-center md:items-start gap-4" data-id="element-129">
            <h4 className="font-serif text-lg text-text-dark mb-2" data-id="element-130">Visit Us</h4>
            <p className="text-text-dark/70 text-sm" data-id="element-131">San Ramon, CA</p>
            <a href="mailto:hello@beclinical.com" className="text-text-dark/70 hover:text-gold transition-colors text-sm" data-id="element-132">
              hello@beclinical.com
            </a>
            <div className="flex gap-4 mt-4" data-id="element-133">
              <a href="#" aria-label="Instagram" className="text-text-dark/50 hover:text-gold transition-colors" data-id="element-134">
                <InstagramIcon size={20} data-id="element-135" />
              </a>
              <a href="#" aria-label="Facebook" className="text-text-dark/50 hover:text-gold transition-colors" data-id="element-136">
                <FacebookIcon size={20} data-id="element-137" />
              </a>
              <a href="#" aria-label="Yelp" className="text-text-dark/50 hover:text-gold transition-colors" data-id="element-138">
                <YelpIcon size={20} data-id="element-139" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-divider pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-text-dark/40 text-center md:text-left" data-id="element-140">
          <p data-id="element-141">
            © {new Date().getFullYear()} Be Clinical San Ramon. All rights
            reserved.
          </p>
          <div className="flex gap-4" data-id="element-142">
            <a href="#" className="hover:text-text-dark transition-colors" data-id="element-143">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-text-dark transition-colors" data-id="element-144">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}